import "core-js/modules/es6.object.assign";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import "core-js/modules/es6.regexp.replace";
import { memo as t, useMemo as e, createElement as o, useEffect as a } from "react";
import { MapToComponents as n } from "react-map-to-components";
import l from "tiny-warning";

var i = function i(t) {
  return (null == t ? void 0 : t.__typename) ? t.__typename.replace(/^Prismic/, "") : "";
},
    p = function p(t, e) {
  var o, a;
  return null !== (o = null !== (a = t.id) && void 0 !== a ? a : t.key) && void 0 !== o ? o : e;
},
    r = function r(t, e) {
  var o = {};

  for (var _a in e) {
    o[_a] = t(e[_a], _a);
  }

  return o;
},
    s = function s(_ref) {
  var t = _ref.type;
  return a(function () {
    l(!1, "Missing mapping for slice with type \"".concat(String(t), "\""));
  }, [t]), "development" !== process.env.NODE_ENV ? null : o("div", {
    style: {
      all: "unset",
      backgroundColor: "#ff8a91",
      color: "red",
      display: "block",
      fontFamily: "system-ui",
      fontSize: "16px",
      padding: "64px 16px",
      textAlign: "center",
      opacity: .5
    }
  }, o("p", {
    style: {
      fontWeight: "bold",
      fontSize: "1.5em",
      marginBottom: "0.5em"
    }
  }, "Missing mapping for slice type: ", t), o("p", {
    style: {
      fontSize: "0.9em"
    }
  }, "Add the missing type to your slices map"));
},
    m = function m(t) {
  var a = t.map,
      l = t.mapOverrides,
      _t$list = t.list,
      m = _t$list === void 0 ? [] : _t$list,
      _t$listMiddleware = t.listMiddleware,
      d = _t$listMiddleware === void 0 ? function (t) {
    return t;
  } : _t$listMiddleware,
      _t$getKey = t.getKey,
      c = _t$getKey === void 0 ? p : _t$getKey,
      _t$getType = t.getType,
      u = _t$getType === void 0 ? i : _t$getType,
      _t$defaultMapDataToPr = t.defaultMapDataToProps,
      y = _t$defaultMapDataToPr === void 0 ? function (_ref2) {
    var t = _ref2.type;
    return {
      type: t
    };
  } : _t$defaultMapDataToPr,
      _t$mapDataToContextEn = t.mapDataToContextEnhancer,
      v = _t$mapDataToContextEn === void 0 ? function (t) {
    return t;
  } : _t$mapDataToContextEn,
      _t$mapDataToPropsEnha = t.mapDataToPropsEnhancer,
      f = _t$mapDataToPropsEnha === void 0 ? function (t) {
    return t;
  } : _t$mapDataToPropsEnha,
      g = _objectWithoutProperties(t, ["map", "mapOverrides", "list", "listMiddleware", "getKey", "getType", "defaultMapDataToProps", "mapDataToContextEnhancer", "mapDataToPropsEnhancer"]),
      T = e(function () {
    return r(function (t, e) {
      var o, a;
      return null !== (o = null == l || null === (a = l[e]) || void 0 === a ? void 0 : a.call(l, t)) && void 0 !== o ? o : t;
    }, a);
  }, [a, l]),
      D = e(function () {
    return r(function (t) {
      return t.mapDataToProps ? function (e) {
        var o;
        return f(null == t || null === (o = t.mapDataToProps) || void 0 === o ? void 0 : o.call(t, e), e);
      } : y ? function (t) {
        return f(y(t), t);
      } : function (t) {
        return f(void 0, t);
      };
    }, a);
  }, [a, y, f]),
      x = e(function () {
    return r(function (t) {
      return t.mapDataToContext ? function (e) {
        var o;
        return v(null == t || null === (o = t.mapDataToContext) || void 0 === o ? void 0 : o.call(t, e), e);
      } : function (t) {
        return v(void 0, t);
      };
    }, a);
  }, [a, v]),
      P = e(function () {
    return d(m);
  }, [m, d]);

  return o(n, Object.assign({
    getKey: c,
    getType: u,
    default: s,
    defaultMapDataToProps: y,
    list: P,
    map: T,
    mapDataToProps: D,
    mapDataToContext: x
  }, g));
};

m.displayName = "MapSlicesToComponents";
var d = t(m);
export default d;